import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export default function Navbar({pokemonFilter}) {
  return (
    <Box sx={{ flexGrow: 1, marginBottom: '2em' }}>
      <AppBar position="static" sx={{backgroundColor: '#4a8dc8'}}>
        <Toolbar>
          <Box display='flex' justifyContent='space-between' width='100%'>
            <Box display='flex' alignItems='center'>
              <Typography sx={{color: 'black', fontFamily: 'saira', fontSize: '1.2em'}}>/*</Typography>
              <Typography sx={{fontFamily: 'saira', fontSize: '1.2em'}}>G.H DEV</Typography>
              <Typography sx={{color: 'black', fontFamily: 'saira', fontSize: '1.2em'}}>*/</Typography>
            </Box>
          <Box component="img" src="/assets/poke-logo.png" height="3em" />
            <Search sx={{display: 'flex', alignItems: 'center'}} onChange={(e) => pokemonFilter(e.target.value.toLowerCase())}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Pesquisar Pokémon"
                inputProps={{ 'aria-label': 'search' }}
              />
            </Search>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
